export const EventName = {
  /** Care+ flow: user selected who care is for (step 1, before contact). */
  CARE_PLUS_INQUIRY_RECIPIENT_SELECT: "care-plus-inquiry-recipient-select",
  /** Care+ inquiry (non–lead-form) submit outcome for Segment. */
  CARE_PLUS_INQUIRY_SUBMIT: "care-plus-inquiry-submit",
  CAREER_FORM_SUBMIT: "career-form-submit",
  /** V1 lead chatbot — Segment tracking plan (DEX-1983). */
  CHAT_ASSISTANT_MESSAGE_RECEIVED: "Chat Assistant Message Received",
  CHAT_CONFIRMATION_SCREEN_SHOWN: "Chat Confirmation Screen Shown",
  CHAT_CONVERSATION_ENDED: "Chat Conversation Ended",
  CHAT_CONVERSATION_STARTED: "Chat Conversation Started",
  CHAT_ERROR: "Chat Error",
  CHAT_FORM_FALLBACK_SHOWN: "Chat Form Fallback Shown",
  CHAT_LEAD_SUBMITTED: "Chat Lead Submitted",
  CHAT_MESSAGE_SENT: "Chat Message Sent",
  CHAT_WIDGET_OPENED: "Chat Widget Opened",
  CTA_BTN_INTERACTION: "cta-btn-interaction",
  LEAD_FORM_MULTI_SELECT_CONTINUED: "Lead Form Multi Select Continued",
  LEAD_FORM_RADIO_SELECTED: "Lead Form Radio Selected",
  LEAD_FORM_STEP_CONTINUED: "Lead Form Step Continued",
  PHONE_NUMBER_CLICK: "phone-number-click",
  REQUEST_INFORMATION_FORM_SUBMIT: "request-information-form-submit",
  SERVICE_LEAD_FORM_SUBMIT: "service-lead-form-submit",
  TRACKED_CLICK: "tracked_click",
  URL_PARAMS: "URL Params",
};

export type EventNameType = (typeof EventName)[keyof typeof EventName];
